// @flow

export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';

export const updateFilters = (filters: Filters) => ({
  type: UPDATE_FILTERS,
  filters,
});

export const resetFilters = () => ({
  type: RESET_FILTERS,
});

const reducer = (state: Object = {}, action: Object = {}) => {
  switch (action.type) {
    case UPDATE_FILTERS:
      return Object.assign({}, state, action.filters);
    case RESET_FILTERS:
      return {};
    default:
      return state;
  }
};

export default reducer;
